/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { StructuredJobProgressDto } from "./StructuredJobProgressDto";

export const publicJobWithResultDtoStatusEnum = {
    "SCHEDULED": "SCHEDULED",
    "WAITING": "WAITING",
    "WAITING_CHILDREN": "WAITING_CHILDREN",
    "IN_PROGRESS": "IN_PROGRESS",
    "COMPLETED": "COMPLETED",
    "FAILED": "FAILED",
    "CANCELLED": "CANCELLED"
} as const;

export type PublicJobWithResultDtoStatusEnum = (typeof publicJobWithResultDtoStatusEnum)[keyof typeof publicJobWithResultDtoStatusEnum];

export type PublicJobWithResultDto = {
    /**
     * @description Unique identifier of the job
     * @type string
    */
    id: string;
    /**
     * @description Current status of the job
     * @type string
    */
    status: PublicJobWithResultDtoStatusEnum;
    /**
     * @description Progress data of the job
     * @type object | undefined
    */
    progress?: object;
    /**
     * @description Timestamp when the progress was last updated
     * @type string | undefined, date-time
    */
    progressUpdatedAt?: string;
    /**
     * @description Progress percent (extracted from progress field)
     * @type number | undefined
    */
    progressPercent?: number;
    /**
     * @description Additional progress data (when progress is an object)
    */
    progressData?: StructuredJobProgressDto;
    /**
     * @description Timestamp when the job was processed
     * @type string, date-time
    */
    processedOn: string;
    /**
     * @description Timestamp when the job was finished (completed, failed, or cancelled)
     * @type string | undefined, date-time
    */
    finishedOn?: string;
    /**
     * @description Result object from the completed job
     * @type object | undefined
    */
    result?: object;
};